import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { DEFAULT_SYSTEMSETTINGS } from "../data/constants";

export const useSettingValue = (key: string) => {
  const settings = useSelector((state: RootState) => state.settings.settings);
  return settings.find((s) => s.property === key)?.value ?? DEFAULT_SYSTEMSETTINGS[key] ?? null;
};
